<app-dialog
  #dialog
  [key]="'meeting-visibility'"
  [action]="'meeting-visibility'"
  [headerTheme]="'simple'"
  [title]="'Visibilidade da call'"
  [maxWidth]="'560px'">
  <div class="visibility">
    <p class="visibility__note">
      @if (canManage()) {
        Só quem participou pode mudar.
      } @else {
        <i class="pi pi-lock" aria-hidden="true"></i>
        Só quem participou pode mudar. Você está vendo só para leitura.
      }
    </p>

    @if (privateText(); as text) {
      <div class="visibility__private" role="status">
        <i class="pi pi-lock" aria-hidden="true"></i>
        <span>{{ text }}</span>
      </div>
    }

    @for (row of rows(); track row.audience) {
      <section
        class="visibility__row"
        [class.visibility__row--blocked]="row.audience === 'Client' && clientBlockedByAi()"
        [attr.aria-labelledby]="'visibility-' + row.audience">
        <div class="visibility__row-head">
          <div class="visibility__row-text">
            <h4 class="visibility__row-title" [id]="'visibility-' + row.audience">
              <i [class]="row.icon" aria-hidden="true"></i>
              {{ row.title }}
              @if (row.audience === 'Client' && !visibility()?.clientFeatureEnabled) {
                <span
                  class="visibility__soon"
                  title="O cliente ainda não vê nenhuma call: a chave fica gravada para quando o portal abrir"
                  >em breve</span
                >
              }
            </h4>
            <p class="visibility__reason">{{ row.reason }}</p>
            @if (row.origin) {
              <p class="visibility__origin">
                {{ row.origin }}
                @if (row.canReset && canManage()) {
                  ·
                  <button
                    type="button"
                    class="visibility__reset"
                    [disabled]="!!busy()"
                    (click)="resetToAutomatic(row.audience)">
                    Voltar ao automático
                  </button>
                }
              </p>
            }
          </div>
          <div
            class="visibility__switch"
            [class.visibility__switch--locked]="row.state.locked"
            [title]="row.state.locked ? 'Travada pela regra; nem a decisão manual muda' : ''">
            @if (row.state.locked) {
              <i class="pi pi-lock visibility__lock" aria-hidden="true"></i>
            }
            @for (v of [switchVersion()]; track v) {
              <app-switch
                [checked]="row.state.visible"
                [disabled]="!canManage() || !row.state.canToggle || !!busy()"
                [ariaLabel]="(row.state.visible ? 'Desligar ' : 'Ligar ') + row.title"
                (sendChecked)="toggle(row.audience, $event)" />
            }
          </div>
        </div>

        @if (row.audience === 'Client' && clientReasons().length) {
          <ul class="visibility__ai-reasons">
            @for (reason of clientReasons(); track $index) {
              <li>
                <i class="pi pi-sparkles" aria-hidden="true"></i>
                <span>
                  <strong>{{ reason.label }}:</strong> {{ reason.explanation }}
                  @if (reason.clock) {
                    <span class="visibility__clock">({{ reason.clock }})</span>
                  }
                </span>
              </li>
            }
          </ul>
        }
      </section>
    }
  </div>

  <ng-template #footer>
    <div class="visibility__footer">
      <app-button
        [label]="'Como funciona a visibilidade'"
        [icon]="'pi pi-info-circle'"
        [theme]="'link'"
        [type]="'button'"
        (sendButtonClick)="showRules()" />
      <div class="visibility__footer-actions">
        @if (canManage()) {
          @if (visibility()?.isPrivate) {
            <app-button
              [label]="'Desfazer Privar'"
              [icon]="'pi pi-lock-open'"
              [theme]="'white'"
              [type]="'button'"
              [isLoading]="busy() === 'private'"
              [disabled]="!!busy()"
              (sendButtonClick)="undoPrivate()" />
          } @else {
            <app-button
              [label]="'Privar'"
              [icon]="'pi pi-lock'"
              [theme]="'danger'"
              [type]="'button'"
              [isLoading]="busy() === 'private'"
              [disabled]="!!busy()"
              (sendButtonClick)="makePrivate()" />
          }
        }
        <app-button
          [label]="'Fechar'"
          [theme]="'white'"
          [type]="'button'"
          (sendButtonClick)="close()" />
      </div>
    </div>
  </ng-template>
</app-dialog>
